/* eslint-disable max-len */
import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

export const CustomAPISection = (props, context) => {
    const CONSTANTS = context.CONSTANTS;
    return (
        <div id="custom">
            <h1 className="blue">Custom APIs & Extended Access</h1>
            <section className="narrow">
                <p>
            We develop custom endpoints and offer extended access to deliver the most engaging experience for a partner and their users.
                </p>
                <h4>What type of custom APIs?</h4>
                <p>
            Custom APIs that increase searches and shares. This tends to be unique to a particular partner’s use case and userbase. For example, using the anonymous ID (anon_id) parameter which personalizes the GIF experience per user by tuning Tenor’s algorithms towards a user’s preferences over time. Note anonymous ID (anon_id) and other custom work requires development partner by partner and the best candidates are partners with a sizable install base, eg DAU of tens of millions or more.
                </p>
                <h4>What type of extended access?</h4>
                <p>We also provide extended access to a number of features that enable a partner to have more granular controls in creating the GIF experience that best fits their users. Note like the custom work above, the best candidates for extended access are partners with a sizable install base. Examples include:</p>
                <ul className="bullet-list indent-align">
                    <li>
                        <b>Flagging</b> - ability for a partner to flag a particular GIF, notifying Tenor and removing the GIF from the partner’s library until investigated
                    </li>
                    <li>
                        <b>Graylist</b> - access to a list of search terms that can be blocked. This functions independently of contentfilter
                    </li>
                    <li>
                        <b>Tagging</b> - access to richer metadata per GIF
                    </li>
                    <li>
                        <b>Regional Filters</b> - the capability to limit certain content based on a particular locale or locales
                    </li>
                </ul>
                <h4>How do I learn more?</h4>
                <p>Please email <a href={`mailto:api@${CONSTANTS.MAIL_DOMAIN}?subject=Custom%20APIs%20%26%20Extended%20Access`}>api@{CONSTANTS.MAIL_DOMAIN}</a> and we will quickly get back to you with additional information.</p>
            </section>
        </div>
    );
};
